import { render, staticRenderFns } from "./QuickMailService.vue?vue&type=template&id=5044271d&"
import script from "./QuickMailService.vue?vue&type=script&lang=js&"
export * from "./QuickMailService.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/formats.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports